import {
  Component,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Indicator } from '../../../models/indicator';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { HeaderComponent } from '../../atoms/header/header.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SharedModule } from 'primeng/api';
import { IndicatorDataListComponent } from '../indicator-data-list/indicator-data-list.component';
import { AlertStyleDirective } from '../../../directives/alert-style.directive';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';

@Component({
  selector: 'app-confirm-delete-indicator',
  standalone: true,
  imports: [
    AlertComponent,
    ButtonModule,
    CheckboxModule,
    ChipModule,
    ConfirmDialogModule,
    DividerModule,
    HeaderComponent,
    ScrollPanelModule,
    SharedModule,
    IndicatorDataListComponent,
    AlertStyleDirective,
  ],
  templateUrl: './confirm-delete-indicator.component.html',
  styleUrl: './confirm-delete-indicator.component.scss',
})
export class ConfirmDeleteIndicatorComponent implements OnInit, OnChanges {
  readonly indicatorStore = inject(IndicatorStore);
  readonly indicatorDataStore = inject(IndicatorDataStore);
  @Input() indicator!: Indicator;
  indicatorChildren?: Indicator[];
  indicatorHasData = false;

  /**
   * Lifecycle hook called after Angular has initialized all data-bound properties of a directive.
   * This method is used to initialize the component after its creation and perform setup tasks such as
   * retrieving or verifying data required for the component.
   *
   * @return {void} This method does not return any value.
   */
  ngOnInit(): void {
    this.checkForData();
  }

  /**
   * Lifecycle hook method that is called when any data-bound property of a directive changes.
   * It detects changes to the input properties of the component and performs necessary actions.
   *
   * @param {SimpleChanges} changes - An object of current and previous property values. The keys are property names, and the values are SimpleChange objects that contain the current and previous values.
   * @return {void} This method does not return a value.
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.checkForData();
  }

  /**
   * Checks for associated data based on the indicator state and updates the indicatorHasData flag accordingly.
   * The method evaluates whether there is data for the current indicator or its children, based on the indicator's configuration.
   *
   * @return {void} This method does not return a value.
   */
  checkForData(): void {
    if (this.indicator.isSet) {
      this.indicatorChildren = this.indicatorStore.filterByParent(
        this.indicator._id
      );
      for (const child of this.indicatorChildren) {
        this.indicatorHasData = this.indicatorDataStore.indicatorHasData(
          child._id
        );
        if (this.indicatorHasData) break;
      }
    } else {
      this.indicatorHasData = this.indicatorDataStore.indicatorHasData(
        this.indicator._id
      );
    }
  }
}
